
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/create",
      function () {
        return require("private-next-pages/collections/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/create"])
      });
    }
  